<template>
  <div class="topic" >
		<div class="topic-wrap">
      <billboards ref="billboard" :billboardList="billboardsList" v-show="billboardsList.length"></billboards>
      <recommend ref="recommend" :recommendList="recommendList" myStyle="padding-bottom:15px;" @click-icon="clickRecommend"></recommend>
      <div ref="topicBar" class="topic-bar border-radius-8" :class="[isScrollFixBar, isShowAllMenus?'z-index-0':'']" v-if="!getProductError || goodsListFormat.length">
        <div :class="['default'].concat(defaultClass)" @click="sortByDefault()">
          <span>推荐</span>
        </div>
        <div :class="['salesCount'].concat(salesCountClass)" @click="sortBySalesCount()">
          <span>销量</span>
          <div class="icon-content">
            <icon size="12" color="rgb(189,192,197)">sousuo-paixujiantoushang</icon>
            <icon size="12" color="rgb(189,192,197)">sousuo-paixujiantouxia</icon>
          </div>
        </div>
        <div :class="['price'].concat(priceClass)" @click="sortByPrice()">
          <span>价格</span>
          <div class="icon-content">
            <icon size="12" color="rgb(189,192,197)">sousuo-paixujiantoushang</icon>
            <icon size="12" color="rgb(189,192,197)">sousuo-paixujiantouxia</icon>
          </div>
        </div>
      </div>
      <div
        v-if="!getProductError || goodsListFormat.length"
        class="topic-list clearfix"
        v-infinite-scroll="loadMore"
        :infinite-scroll-disabled="loading"
        infinite-scroll-distance="50">
        <goods-list
        :goodsList="goodsListFormat"
        :viewTrackData="viewTrackData"
        @click-goods-item="clickItem"
        :showType="$attrs.showType"
        ></goods-list>
      </div>
      <div v-if="isShowNoMore" class="no-more">- 我是有底线的 -</div>
      <p v-show="!isShowNoMore" class="page-infinite-loading" :class="{'page-loading-visible': !loading}">
        <mt-spinner type="fading-circle"></mt-spinner>
        加载中...
      </p>
		</div>
  </div>
</template>
<script>
  import op from 'object-path'
  import { resolveActionPath, goodsListFormat } from '../../../util/function'
  import { InfiniteScroll, Spinner } from 'mint-ui'
  import billboards from '../../../components/billboards'
  import recommend from '../../../components/recommend'
  import goodsList from '../../../components/goods-list'
  import decimalPrice from '../../../components/decimal-price'
  import icon from '../../../components/icon'
  import { trackData } from '../../../directives/track.js'
  import _ from 'underscore'
  import defaultPage from '../../../components/none-order.vue'
  import keepAliveMixin from '../../../mixins/common/keep-alive.js'

  const DefaultPageSize = 10
  const DefaultPageNum = 1

  export default {
    mixins: [keepAliveMixin],
    props: ['categoryId', 'isShowAllMenus'],
    data() {
      return {
        sortF: {
          key: 'default',
          type: 'asc',
        },
        currentPageNum: DefaultPageNum,
        loading: true,
        allLoaded: false,
        recommendList: [],
        billboardsList: [],
        goodsList: [],
        goodsTotalNum: 0,
        isScrollFixBar: '',
        viewTrackData: {
          trackId: 2002,
          algorithmId: null,
          bId: null,
          // data: [],
        },
        getProductError: false, //尾加载失败标识

        // 是否展示筛选栏
        isShowFilter: false, //deflaut: false
        // 存储点击筛选之前的sort
        oldSort: {}
      }
    },
    components: {
      [Spinner.name]: Spinner,
      billboards,
      icon,
      recommend,
      goodsList,
      'decimal-price': decimalPrice,
      defaultPage,
    },
    directives: {
      InfiniteScroll,
    },
    methods: {
      clickRecommend(id) {
        // trackData({id:320, p:[this.categoryId, id]})
      },
      clickItem(i) {
        if(this.sortF.key === 'default') {
          const indexStart = (i - 5 < 0) ? 0 : (i-5)
          const indexEnd = (i + 5 > this.goodsListFormat.length) ? this.goodsListFormat.length : (i + 5)
          const paramList = this.goodsListFormat.slice(indexStart, indexEnd)
          const spuList = _.filter(paramList.map(item => {
            return item.id
          }), spuId => {
            return spuId !== this.goodsListFormat[i].id
          })
          console.log(this.goodsListFormat,'-this.goodsListFormat-');
          // trackData({id:347, p:[this.viewTrackData.data[0], this.categoryId, ...spuList]})
          trackData({
            id: 3002,
            data: {
              aId: this.viewTrackData.algorithmId + '',
              bId: this.categoryId + '',
              pId: this.goodsListFormat[i].id + ''
            }
          })
        }
      },
      handleScroll() {
        if(!this.$refs.topicBar) {
          return window.removeEventListener('scroll', this.handleScroll)
        }
        let height = this.$refs.topicBar.offsetTop
        if(window.scrollY + 73 > height) {
          return this.isScrollFixBar = 'scrollFixBar'
        }
        return this.isScrollFixBar = ''
      },
      getDefaultGoodsList() {
        const data = {
          parentId: this.categoryId,
          pageSize: DefaultPageSize,
          pageNum: DefaultPageNum,
        }
        this.getRecommendByCategory(data)
      },
      sortByDefault() {
        this.sortF = {
          key: 'default',
          type: 'asc'
        }
      },
      sortBySalesCount() {
        this.sortF = {
          key: 'salesCount',
          type: this.sortF.key === 'salesCount' && this.sortF.type === 'desc' ? 'asc' : 'desc'
        }
      },
      sortByPrice() {
        this.sortF = {
          key: 'price',
          type: this.sortF.key === 'price' && this.sortF.type === 'asc' ? 'desc' : 'asc'
        }
      },
      sortSelect(){
        this.sortF = {
          key: 'select',
        }
        this.toggerSelect()
        this.getCategorSelectyOptions()
      },
      // togger 筛选栏
      toggerSelect(v){
        this.isShowFilter = v
      },
      // 获取 筛选栏 数据
      getCategorSelectyOptions(){
        let self = this
        this.$store.dispatch('filterOptionList', {
          categoryId: this.categoryId,
        }).then(data => {
          if(data){
            // 显示弹窗
            self.toggerSelect(true)
          }
          }).catch(e => {
            console.log("筛选栏 err", e)
          })
      },
      loadMore() {
        if (this.goodsTotalNum <= this.goodsList.length || this.loading || !this.isInActive) {
          return;
        }
        if( this.sortF.key === 'default') {
          const data = {
            parentId: this.categoryId,
            pageSize: DefaultPageSize,
            pageNum: this.currentPageNum + 1,
          }
          this.getRecommendByCategory(data)
        }else {
          const data = {
            categoryId: this.categoryId,
            pageSize: DefaultPageSize,
            pageNum: this.currentPageNum + 1,
            sortKey: this.sortF.key,
            sortType: this.sortF.type,
            categoryType: 1, // 1 表示一级品类
          }

          this.getCategoryProducts(data)
        }

      },
      getCategoryProducts(data) {
        this.loading = true
        this.getProductError = false
          return this.$store.dispatch('getCategoryProducts', data).then((data) => {
            this.loading = false
            this.getProductError = false
            this.goodsTotalNum = data.page.total
            this.currentPageNum = data.page.pageNum,
            this.goodsList = this.goodsList.concat(data.list)
          }).catch(e => {
            this.loading = false
            this.getProductError = true
          })
      },
      getRecommendByCategory(data) {
        this.loading = true
        this.getProductError = false
          return this.$store.dispatch('getRecommendByCategory', data).then(data => {
            this.loading = false
            this.getProductError = false
            this.goodsTotalNum = data.page.total
            this.goodsList = this.goodsList.concat(data.list)
            this.currentPageNum = data.page.pageNum
            this.viewTrackData.algorithmId = data.algorithmId
          }).catch(e => {
            this.loading = false
            this.getProductError = true
          })
      },
      // 筛选提交
      submitFilterOptionData(data){
        let self = this
        console.log("筛选提交: ", data, this.oldSort)
        let option = {
          condition: {...data},
          categoryId: this.categoryId,
          categoryType: 0, // 0:默认二级品类 1:一级品类
          pageSize: DefaultPageSize,
          pageNum: DefaultPageNum,
          sortKey: op(this.oldSort).get('key'),
          sortType: op(this.oldSort).get('type'),
        }
        console.log("提交的数据: ", option)

        return this.$store.dispatch('submitFilterOption', option).then(data => {
          console.log("提价筛选之后的data: ", data)
            self.goodsTotalNum = data.page.total
            self.currentPageNum = data.page.pageNum,
            self.goodsList = data.list
            self.toggerSelect(false)
        }).catch(e => {
            self.getProductError = true
          })
      },
      init(){
        window.scrollTo(0,0)
        // 拉商品
        this.goodsList = []
        this.currentPageNum = DefaultPageNum
        this.getDefaultGoodsList()
        // this.viewTrackData.data[0] = this.categoryId
        this.viewTrackData.bId = this.categoryId
        // 拉二级品类banner
        this.$store.dispatch('getCategoryRecommend', {
          type: 21,
          businessId: this.categoryId,
        }).then(data => {
          this.recommendList = data.map(item => {
            return {
              id: item.bannerId,
              imgUrl: item.imgUrl,
              href: resolveActionPath(item),
              title: item.masterTitle,
            }
          })
        }).catch(e => {
          console.log(e)
          this.recommendList = []
        })

        // 拉广告banner
        this.$store.dispatch('getCategoryBanner', {
          categoryId: this.categoryId,
        }).then(data => {
          this.billboardsList = data.map(item => {
            return {
              id: item.bannerId,
              href: resolveActionPath(item),
              imgUrl: item.imgUrl,
            }
          })
        }).catch(e => {
          console.log(e)
          this.billboardsList = []
        })
      }
    },
    computed: {
      topicTitle() {
        return this.$store.state.topic.topicBillboardList.masterTitle
      },
      goodsListFormat() {
        const list = goodsListFormat(this.goodsList)
        return list
      },
      defaultClass() {
        return this.sortF.key === 'default' ? ['active'] : []
      },
      salesCountClass() {
        return this.sortF.key === 'salesCount' ?
          this.sortF.type === 'asc' ? ['active', 'asc'] : ['active', 'desc']
          : []
      },
      priceClass() {
        return this.sortF.key === 'price' ?
          this.sortF.type === 'asc' ? ['active', 'asc'] : ['active', 'desc']
          : []
      },
      selectClass(){
        return this.sortF.key === 'select' ? ['active'] : []
      },
      isShowNoMore() {
        return (this.currentPageNum * DefaultPageSize >= this.goodsTotalNum) && !this.loading && !this.getProductError
      },

    },
    watch: {
      sortF(newVal, oldVal) {
        if(newVal.key === 'select'){
          console.log("筛选newVal, oldVal", newVal, oldVal)
          if(oldVal.key === "select"){
            return
          }
          this.oldSort = {...oldVal}
          console.log("筛选不刷新页面")
          return
        }
        const self = this;
        if (newVal.key === oldVal.key && newVal.type === oldVal.type) {
          return
        }

        this.currentPageNum = DefaultPageNum
        this.goodsList = []
        if (newVal.key === 'default') {
          this.getDefaultGoodsList()
          return
        }

        const data = {
          categoryId: this.categoryId,
          pageSize: DefaultPageSize,
          pageNum: DefaultPageNum,
          sortKey: this.sortF.key,
          sortType: this.sortF.type,
          categoryType: 1,
        }
        this.getCategoryProducts(data)
      }
    },
    mounted() {
      window.addEventListener('scroll', this.handleScroll)
      console.log("_inactved", this._inactive, this)
    }
  }
</script>

<style lang="less" scoped>
	.topic {
    min-height: calc(~'100vh - 93px');
  }
</style>
<style lang="less" scoped>
  @import '../../../../stylesheet/variable';
  @tabBarHeight: 49px;
  @headerHeight: 44px;
  @appTipHeight: 49px;
  .fixBarWithAppTip, .scrollFixBarWithTip{
    position: fixed !important;
    top:(@headerHeight + @appTipHeight);
  }
  .fixBar, .scrollFixBar {
    position: fixed !important;
    top: 73px;
    margin-left: -10px;
    border-radius: 0px !important;
  }
  .fixList {
    padding-top: 59px !important;
  }
	.topic {
    .search {
      position: relative;
      height: 44px;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      i {
        margin-right: 10px;
      }
    }
    .topic-bar {
      position: relative;
      height: 44px;
      display: flex;
      width: 100%;
      background-color: #ffffff;
      z-index:10;
      &::after {
        .setBottomLine();
      }
      & > div {
        width: 33.3333%;
        height: 44px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 14px;
        position: relative;
        color: #797d82;
        .icon-content{
          display: flex;
          flex-direction: column;
          align-items: center;
          height: 100%;
        }
        i {
          position: relative;
        }
         i:nth-child(1) {
          top: 10px;
        }
        i:nth-child(3) {
          bottom : 8px;
        }
        &.active {
          color: @reddish;
          &.asc i:nth-child(1) {
            color: @reddish !important;
          }
          &.desc i:nth-child(2) {
            color: @reddish !important;
          }
        }
      }
      .select{
        .icon{
            width: 14px;
            height: 14px;
            &:nth-child(2){
              display: block;
            }
            &:nth-child(3){
              display: none;
            }
        }
        &.active {
          color: @reddish;
          .icon{
            &:nth-child(2){
              display: none;
            }
            &:nth-child(3){
              display: block;
            }
          }
        }

      }
    }
    .z-index-0{
      z-index: 0,
    }
    .topic-list {
      margin: 0;
      list-style: none;
      .topic-item {
        float: left;
        width: 50%;
        .item-wrap {
          width: 100%;
          padding: 5px 7.5px;
          display: inline-block;
          position: relative;
          box-sizing: border-box;
          @media (max-width: 375px) and (min-width: 320px) {
            height: 200px;
          }
          @media (min-width: 375px) {
            height: 235px;
          }
          .img-wrap {
            @media (max-width: 375px) and (min-width: 320px) {
              width: 142.5px;
              height: 142.5px;
              margin: 0 auto;
            }
            @media (min-width: 375px) {
              width: 165px;
              height: 165px;
              margin: 0 auto;
            }
            display: flex;
            justify-content: flex-start;
            align-items: center;
          }
          .item-describe {
            @media (max-width: 375px) and (min-width: 320px) {
              width: 142.5px;
              margin: 0 auto;
            }
            @media (min-width: 375px) {
              width: 165px;
              margin: 0 auto;
            }
            padding-top: 13px;
            line-height: 17px;
            .masterName {
              display: inline-block;
              width: 100%;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              top: 0;
              left: 0;
              font-size: 15px;
              color: rgb(25, 26, 27);
            }
            .price {
              font-size: 15px;
              color: rgb(192, 49, 49);
              .decimal {
                font-size: 10px;
              }
              i {
                font-size: 11px;
                font-style: normal;
              }
            }
            .market-price {
              text-decoration: line-through;
              font-size: 11px;
              color: rgb(189, 192, 197);
            }
            .salesCount {
              font-size: 11px;
              color: rgb(189, 192, 197);
              position: absolute;
              right: 10px;
            }
          }
        }
      }
    }
    .page-infinite-loading {
      text-align: center;
      height: 50px;
      line-height: 50px;
      span {
        display: inline-block;
        vertical-align: middle;
        margin-right: 5px;
      }
    }
    .page-loading-visible {
      visibility: hidden;
    }
    .no-more {
      text-align: center;
      padding: 15px 0;
      color: rgb(189, 192, 197);
    }
	}
</style>
